import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "发送邮件", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, "主题", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, "内容", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, "附件", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("发送")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.show) = $event)),
    centered: "",
    width: "900px"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      (_ctx.entityType === 'bill')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showEmailHistory && _ctx.showEmailHistory(...args))),
            style: {"margin-left":"10px"}
          }, "查看历史"))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        loading: _ctx.loading,
        flat: "",
        onClick: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: _ctx.loading,
        flat: "",
        disabled: _ctx.loading,
        onClick: _ctx.sendEmail
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { class: "email_holder" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "模板" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        options: _ctx.templateItems,
                        value: _ctx.selectedTemplateId,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTemplateId) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "发送(From Pipeline Cards)" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        placeholder: "请在账单详情中的对账联系人中添加发送人邮件地址",
                        options: _ctx.selectedItem.send_to_list.map((x) => ({ text: x, value: x })),
                        mode: "multiple",
                        value: _ctx.selectedSendToList,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSendToList) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "抄送" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        options: _ctx.selectedItem.copy_to_list.map((x) => ({ text: x, value: x })),
                        value: _ctx.selectedCopyToList,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCopyToList) = $event)),
                        mode: "multiple"
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("div", {
                    id: "email_title",
                    contenteditable: "true",
                    class: "email_title margin20",
                    innerHTML: _ctx.selectedItem.title
                  }, null, 8, _hoisted_4),
                  _hoisted_5,
                  _createElementVNode("div", {
                    id: "email_content",
                    contenteditable: "true",
                    class: "email_content margin20",
                    innerHTML: _ctx.selectedItem.content
                  }, null, 8, _hoisted_6),
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox_group, {
                        value: _ctx.selectedFileIdList,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedFileIdList) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItem.file_list, (f) => {
                            return (_openBlock(), _createBlock(_component_a_checkbox, {
                              key: f.id,
                              value: f.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: _ctx.getFileLink(f),
                                  target: "_blank",
                                  style: {"margin-right":"25px"}
                                }, _toDisplayString(f.file_name), 9, _hoisted_8)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}